import useLocalStorageObj from "./useLocalStorageObj";

export default function useBreadCrumbsStorage() {
  const ops = useLocalStorageObj('breadCrumbs', {config: {}, doit: {}, someOtherFeature: {}});
  return {
    breadCrumbs:ops.getObj,
    setBreadCrumbs:ops.setObj
  }
}
